const bucketUrl = 'https://storage.googleapis.com/fplsblog';

// This is to ensure that devs upload assets with meaningful names and not just any random name from Figma.
// This must contain file paths in either of the formats 'dirname/filename' or 'filename'
// NOTE: File names must be separated by '-' or '_' only.

const baseFilePaths = [
  'features/intro-closing-page-illustration.svg',
  'features/team-collaboration-illustration.svg',
  'features/email-notification-illustration.svg',
  'features/data-import-export-illustration.svg',
  'features/team-notification-illustration.svg',
  'features/payment-processor-illustration.svg',
  'features/inventory-payment-illustration.svg',
  'features/pre-populate-form-illustration.svg',
  'features/save-and-continue-illustration.svg',
  'features/response-filters-illustration.svg',
  'features/email-invitation-illustration.svg',
  'features/reports-builder-illustration.svg',
  'features/wordpress-embed-illustration.svg',
  'features/custom-form-url-illustration.svg',
  'features/periodic-notifications-icon.svg',
  'features/document-merge-illustration.svg',
  'features/form-analytics-illustration.svg',
  'features/embedded-form-illustration.svg',
  'features/drag-and-drop-illustration.gif',
  'features/offline-forms-illustration.svg',
  'features/form-styling-illustration.svg',
  'features/form-fields-illustration.svg',
  'features/create-form-illustration.svg',
  'features/email-notifications-icon.svg',
  'features/e-signature-illustration.svg',
  'features/form-customisation-intro.svg',
  'features/team-collaboration-intro.svg',
  'features/mobile-form-illustration.svg',
  'features/calculation-illustration.svg',
  'features/partial-submissions-icon.svg',
  'features/custom-text-illustration.svg',
  'features/timed-form-illustration.svg',
  'features/intro-closing-page-icon.svg',
  'features/data-import-export-icon.svg',
  'features/pre-populate-form-icon.svg',
  'features/custom-sub-domain-icon.svg',
  'features/team-notification-icon.svg',
  'features/payment-processor-icon.svg',
  'features/email-invitation-icon.svg',
  'features/data-collection-intro.svg',
  'features/location-illustration.svg',
  'features/response-filters-icon.svg',
  'features/look-up-illustration.svg',
  'features/qr-code-illustration.svg',
  'features/reports-builder-icon.svg',
  'features/inventory-field-icon.svg',
  'features/wordpress-embed-icon.svg',
  'features/reminder-emails-icon.svg',
  'features/gdpr-compliance-icon.svg',
  'features/custom-form-url-icon.svg',
  'features/stripe-illustration.svg',
  'features/form-building-intro.svg',
  'features/document-merge-icon.svg',
  'features/private-forms-icon.svg',
  'features/notification-intro.svg',
  'features/embedded-form-icon.svg',
  'features/form-sharing-intro.svg',
  'features/logic-illustration.svg',
  'features/form-template-icon.svg',
  'features/drag-and-drop-icon.svg',
  'features/autoresponder-icon.svg',
  'features/offline-forms-icon.svg',
  'features/file-illustration.svg',
  'features/form-styling-icon.svg',
  'features/subscription-icon.svg',
  'features/custom-text-icon.svg',
  'features/form-fields-icon.svg',
  'features/calculation-icon.svg',
  'features/mobile-form-icon.svg',
  'features/analytics-intro.svg',
  'features/custom-css-icon.svg',
  'features/map-marker-icon.svg',
  'features/analytics-icon.svg',
  'features/signature-icon.svg',
  'features/security-intro.svg',
  'features/payment-intro.svg',
  'features/qr-code-icon.svg',
  'features/new-tab-icon.svg',
  'features/arrow-right.svg',
  'features/folder-icon.svg',
  'features/lookup-icon.svg',
  'features/teams-icon.svg',
  'features/logic-icon.svg',
  'features/timer-icon.svg',
  'features/imac-icon.svg',
  'features/save-icon.svg',
  'wavy-pattern-right.svg',
  'features/ssl-icon.svg',
  'features/pci-icon.svg',
  'wavy-pattern-left.svg',
  'logo-black.png',
  'logo-white.svg',
  'logo.png'
].map((path) => `/external-react/${path}`);

const filePaths = [
  ...baseFilePaths,
];

// Returns camelCase version of file name.
export const getFileKey = (str) => {
	return str.replace(/-(\w)/g, (_, letter) => letter.toUpperCase())
	.replace(/_(\w)/g, (_, letter) => letter.toUpperCase());
};

// This function returns and object of file urls with the file key being the camelCase version of the filename.
// Example: The path 'share/facebook-icon-small.svg' can be accessed with files.facebookIconSmall
export const files = filePaths.reduce((acc, filePath) => {
	const fileName = filePath.split('/').pop();
	const fileKey = fileName && getFileKey(fileName.split('.')[0]);
	if (fileName && fileKey) acc[fileKey] = `${bucketUrl}${filePath}`;
	return acc;
}, {});